<template>
  <div class="project_page">

    <hf-header :showLinks="true" width='100%'></hf-header>

    <div class="container">
      <h3>Case Study</h3>
      <h1>Product development of P-Share a blockchain peer to peer sharing application</h1>
      <div class="column_2">
        <div class="project_info">
          <div class="container">
            <h1>Project information</h1>
            <div class="hr"></div>
            <h2>Client:</h2>
            <p>Duality Blockchain Solutions</p>
            <h2>Sector:</h2>
            <p>Blockchain</p>
            <h2>Duration:</h2>
            <p>9 Months</p>
            <h2>Services provided:</h2>
            <div class="services_provided">
              <div class="service" v-for="(service, index) in pshareServices" :key="index">
                <div class="icon">
                  <img v-bind:src="service.img" class="icon"/>
                </div>
                <div class="name">
                  {{service.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- Column 2 -->
      <div class="column_1">
        <h2>
          Ah a little standfirst to emphasise and explore this title a little more an perhaps tell you what great content you’re about to read?
        </h2>
        <h3>The idea</h3>
        <p>To scope out and develop a person to person file sharing application: PShare (or Private Share).  One that allows users to connect directly with individual users as well as groups of users, so they can share and access one another’s files using blockchain technology.
Duality’s vision to build the first decentralised user interface, enabling users to privately and securely share information, negating any reliance on third party servers.  Commissioning Hiddenfield to scope and build the MVP as proof of concept for market testing amongst a small control group before ultimately launching to the healthcare market.
        </p>
        <h3>The HF Model</h3>
        <p>
          The HF model
Having previously worked with one of the Directors, this was Duality’s first engagement in a software application.  As with any project we started with a conversation, determining what it was the client wanted, timescales, budgetary parameters, then scoping out the project into manageable bite-size analysis sprints to deliver the MVP.  Mindful that we were building front end user interface for everyday operators, not just developers.
The beauty of blockchain technology is its traceability, the user always owns their own documents, rather than being stored on an external, unknown and possibly unsecure server.  Once stored, data and files are always there, providing the user with a transparent, secure and traceable audit trail.
        </p>
        <h3>The process</h3>
        <p>
          The Process
We built the front-end application on blockchain tech, using browser technology to create a network from one peer to another.
We created the PShare application using tech framework called “Electron” which wrapped around the Javascript application Node, enabling the application to support and run on various desktop platforms including Windows, Mac and Linux.   Comms between the PShare desktop and the node is done through RPC calls and each PShare application needs to establish direct WebRTC connections with users to be able to share data.

The user’s node enables the transfer of actual data, ensuring a consistent user experience, so no matter which operating system, files look native to the operating system.  A really nice way of linking the user interface design so that the user experience is smoother, sharper and recognisable.

We scoped out the project and split it down into sprints, with Chris, our Lead Engineer managing the entire project from cradle to grave over the 12 months.   Carrying out the communications, file sharing, sending data between links, lifting a lot of the back-end technology, making electron application a reality and interfacing the PShare application with blockchain technology.

With Tarun handling the UI rendering and UX, ensuring the necessary finessing on time and within budget.

By outlining specific user journeys, we were able to split down the project into manageable sprints, running an agile SCRUM process to ensure the project was implemented to brief, on time and within budget.
        </p>
        <h3>The result</h3>
        <p>
The MVP code was released in October (2019) with the updated blockchain MVP being launched to a small user committee for feedback late November (2019).
        </p>
      </div>
    </div><!-- Container -->
    <div class="testimonials">
      <h1>What our clients said</h1>
      <hf-testimonials :testimonials=pShareTestimonials />
    </div>

  </div><!-- Page -->
</template>

<script>

import prodmanIcon from '../assets/icons/delivery-cropped.svg';
import uiuxIcon from '../assets/icons/delivery-cropped.svg';
import qualityIcon from '../assets/icons/delivery-cropped.svg';
import deliveryIcon from '../assets/icons/delivery-cropped.svg';
import devopsIcon from '../assets/icons/delivery-cropped.svg';
import architectIcon from '../assets/icons/delivery-cropped.svg';

const services = {
  prodman: {
    name: "Product Management",
    img: prodmanIcon,
  },
  uiux: {
    name: 'Experience & Design',
    img: uiuxIcon,
  },
  quality: {
    name: 'Testing & QA',
    img: qualityIcon,
  },
  delivery: {
    name: 'Delivery',
    img: deliveryIcon,
  },
  devops: {
    name: 'DevOps & Development',
    img: devopsIcon,
  },
  architect: {
    name: 'Solutions Architecting',
    img: architectIcon,
  }
}

const pshareServices = [
  services.prodman,
  services.uiux,
  services.architect,
  services.devops
]

const pShareTestimonials = ['mike','amir','spencer'];

export default {
  name: 'PShare',
  data: function() {
    return {
      services,
      pshareServices,
      pShareTestimonials,
    }
  },
  methods: {
     scrollToTop() {
          window.scrollTo(0,0);
     }
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables";

.project_page {

  h1 {
    font-size: 24px;
    line-height: 1.24;
    font-weight: bold;

    @media screen and (min-width: $tablet-min) {
      font-size: 42px;
    }
  }

  h2 {
    font-size: 18px;

    @media screen and (min-width: $tablet-min) {
      font-size: 21px;
    }
  }

  .container {
    width: 95%;
    margin: auto;
    overflow: hidden;

    @media screen and (min-width: $tablet-min) {
      width: 60%;
    }

    .column_1 {
      width: 100%;

      @media screen and (min-width: $tablet-min) {
        width: 60%;
        float: left;
      }
    }

    .column_2 {
      width: 80%;
      margin: auto;

      @media screen and (min-width: $tablet-min) {
        width: 30%;
        float: right;
        margin-right: 5%;
      }
    }

  }

  .project_info {

    .container {
      box-sizing: border-box;
      width: 100%;
      padding: 5%;
      border-radius: 6px;
      box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
    }

    h1 {
      font-size: 18px;
    }

    h2 {
      font-size: 16px;
      margin-bottom: 0;
    }

    p {
      font-size: 16px;
      margin: 0;
      line-height:1.6em;
    }

    .hr {
      width: 100%;
      height: 3px;
      background-color: $light-blue;
    }
  }

  .services_provided {

    margin-top: 10px;

    .service {
      display: flex;
      justify-content: flex-start;

      .icon {
        width: 40px;
      }

      .name {
        margin-left: 5px;
        font-size: 14px;
        line-height: 40px;
      }
    }
  }

  .testimonials {
    clear: both;
    margin-top: 40px;
    background-image: url('../assets/bkgs/section-break-shape.svg');
    background-repeat: no-repeat;
    background-position: bottom left;
    padding-bottom: 50px;

    h1 {
      margin-left: 20%;
    }
  }

}

</style>
